import { FC } from "react";
import Select from "react-select";
import { cars } from "constants/cars";
import { Car } from "shared-types";
import { selectStyle } from "components/styled-components/dropdown";
import { Wrapper } from "components/styled-components/generic";

interface CarDropdownProps {
  setCarToShow: (car: Car) => void;
}

const CarDropdown: FC<CarDropdownProps> = ({ setCarToShow }) => {
  return (
    <Wrapper>
      <Select
        placeholder="Bitte wählen Sie das Auto"
        styles={selectStyle}
        options={cars}
        onChange={(opt) => {
          if (opt) {
            const findCar = cars.find((c) => c.id === opt.value);
            findCar && setCarToShow({ ...findCar });
          }
        }}
      />
    </Wrapper>
  );
};

export default CarDropdown;
